import du from '../utils/dom-utilities';
import CONF from '../utils/conf';

/**
 * Adjust padding-top of square-list without title
 */
const squareListAlign = () => {
    const nodes = du.queryAll('[class*="page__layout--2"] .square-list');

    if (nodes.length === 0) {
        return;
    }

    const titles = nodes.map((node) => {
        const title = node.querySelector('.square-list__title');

        if (!title) {
            return 0;
        }

        const marginBottom = parseInt(window.getComputedStyle(title).getPropertyValue('margin-bottom'));

        return (title.offsetHeight + marginBottom);
    });

    if (titles.length === 0) {
        return;
    }

    const offsetHeight = Math.max.apply(Math, titles);

    const squareToAlign = du.queryAll('[class*="page__layout--2"] .square-list--no-title');

    nodes.map((square) => {
        const title = square.querySelector('.square-list__title');

        if (!title) {
            return;
        }

        const marginBottom = parseInt(window.getComputedStyle(title).getPropertyValue('margin-bottom'));
        const offsetWithoutMargin = offsetHeight - marginBottom;

        return title.setAttribute('style', `height: ${offsetWithoutMargin}px`);
    });

    if (squareToAlign.length === 0) {
        return;
    }

    squareToAlign.map((square) => square.setAttribute('style', `padding-top: ${offsetHeight}px`));
};

const addClassToPageLayout = () => {
    const pageLayouts = du.queryAll('.page__layout .page__layout');

    if (pageLayouts.length > 0) {
        pageLayouts.forEach((pageLayout) => {
            const squareList = pageLayout.querySelector('.square-list');

            if (squareList) {
                pageLayout.classList.add('has-square');
            }
        });
    }
};

export default function () {
    addClassToPageLayout();

    if (window.innerWidth > CONF.mq['md']) {
        squareListAlign();
    }

    du.onEvent(window, 'optimized-resize', () => {
        if (window.innerWidth > CONF.mq['md']) {
            squareListAlign();
        }
    });
};



// WEBPACK FOOTER //
// ./src/main/js/components/squareList.js